<template>
  <div class="banner banner-1 bg-cover">

    <div class="imgs-wrapper">
      <img :src="getImagePath('templates/template_1/img/bg/veg.png')" alt="veg" class="d-none d-lg-block">
    </div>

    <Slick :options="settingsSlider" id="sliderSlick" ref="sliderSlick"
           class="banner-slider">

      <div class="banner-item">
        <div class="banner-inner">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-6">
                <h1 class="title">Prawdziwie Włoska</h1>
                <h4>Pizza Roma</h4>
                <p class="subtitle">
                  sos pomidorowy,
                  ser,
                  szynka parmeńska,
                  oliwki,
                  rucola,
                  suszone pomidory
                </p>
                <h4>od 28,00 zł</h4>
                <div class="banner-controls">
                  <router-link to="/menu"
                               class="btn-custom primary">{{ $t('Check our menu') }} <i
                      class="flaticon-shopping-bag"></i>
                  </router-link>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6">
                <img
                    :src="getImagePath('upload/pizzeriamilano/products/roma-5f516d2c2af0c.png','square_600x600')"
                    alt="pizza">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-item">
        <div class="banner-inner">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-6">
                <h1 class="title">Diabelsko Ostra</h1>
                <h4>Pizza Diabelska</h4>
                <p class="subtitle">
                  ser,
                  szynka,
                  salami pepperoni,
                  ostra papryka pepperoni,
                  kukurydza,
                  sos meksykański,
                  tabasco
                </p>
                <h4>od 25,00 zł</h4>
                <div class="banner-controls">
                  <router-link to="/menu"
                               class="btn-custom primary">{{ $t('Check our menu') }} <i
                      class="flaticon-shopping-bag"></i>
                  </router-link>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6">
                <img
                    :src="getImagePath('upload/pizzeriamilano/products/diabelska2-5f516c86a07fc.png','square_600x600')"
                    alt="pizza">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-item">
        <div class="banner-inner">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-6">
                <h1 class="title">Klasyczna</h1>
                <h4>Pizza Prosciutto</h4>
                <p class="subtitle">
                  sos pomidorowy,
                  ser,
                  pieczarki,
                  salami,
                  szynka,
                  cebula
                </p>
                <h4>od 24,00 zł</h4>
                <div class="banner-controls">
                  <router-link to="/menu"
                               class="btn-custom primary">{{ $t('Check our menu') }} <i
                      class="flaticon-shopping-bag"></i>
                  </router-link>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6">
                <img
                    :src="getImagePath('upload/pizzeriamilano/products/prosciutto-5f515af9b54ba.png','square_600x600')"
                    alt="pizza">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-item">
        <div class="banner-inner">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-6">
                <h1 class="title">Polskie smaki</h1>
                <h4>Pizza Chłopska</h4>
                <p class="subtitle">
                  sos pomidorowy,
                  ser,
                  cebula,
                  boczek,
                  jajko,
                  kiełbasa
                </p>
                <h4>od 24,00 zł</h4>
                <div class="banner-controls">
                  <router-link to="/menu"
                               class="btn-custom primary">{{ $t('Check our menu') }} <i
                      class="flaticon-shopping-bag"></i>
                  </router-link>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6">
                <img
                    :src="getImagePath('upload/pizzeriamilano/products/chlopska2-5f5166c5a5203.png','square_600x600')"
                    alt="pizza">
              </div>
            </div>
          </div>
        </div>
      </div>

    </Slick>

    <div class="banner-slider-nav">
      <div class="container">

        <!-- Arrow -->
        <i class="slider-prev fas fa-arrow-left slick-arrow" @click="prev"></i>

        <Slick :options="settingsNavSlider" id="sliderNavSlick" ref="sliderNavSlick"
               :focusOnSelect="true" class="banner-slider-nav-inner">

          <div class="banner-nav-item">
            <div class="banner-nav-item-inner">
              <img
                  :src="getImagePath('upload/pizzeriamilano/products/roma-5f516d2c2af0c.png','square_600x600')"
                  alt="pizza">
              <div class="banner-nav-item-body">
                <h5>Roma</h5>
                <span>od 28,00 zł</span>
              </div>
            </div>
          </div>

          <div class="banner-nav-item">
            <div class="banner-nav-item-inner">
              <img
                  :src="getImagePath('upload/pizzeriamilano/products/diabelska2-5f516c86a07fc.png','square_600x600')"
                  alt="pizza">
              <div class="banner-nav-item-body">
                <h5>Diabelska</h5>
                <span>od 25,00 zł</span>
              </div>
            </div>
          </div>

          <div class="banner-nav-item">
            <div class="banner-nav-item-inner" :class="{'on-sale': false}">
              <!--                <div class="sale">-->
              <!--                  <div class="sale-inner">Promocja-->
              <!--                  </div>-->
              <!--                </div>-->
              <img
                  :src="getImagePath('upload/pizzeriamilano/products/prosciutto-5f515af9b54ba.png','square_600x600')"
                  alt="pizza">
              <div class="banner-nav-item-body">
                <h5>Prosciutto</h5>
                <!--                <span>$9.99</span>-->
                <span>od 24,00 zł</span>
              </div>
            </div>
          </div>

          <div class="banner-nav-item">
            <div class="banner-nav-item-inner">
              <img
                  :src="getImagePath('upload/pizzeriamilano/products/chlopska2-5f5166c5a5203.png','square_600x600')"
                  alt="pizza">
              <div class="banner-nav-item-body">
                <h5>Chłopska</h5>
                <span>od 24,00 zł</span>
              </div>
            </div>
          </div>

        </Slick>

        <!-- Arrow -->
        <i class="slider-next fas fa-arrow-right slick-arrow" @click="next"></i>

      </div>
    </div>

  </div>
</template>
<script>
import Slick from 'vue-slick'
import '../../assets/css/plugins/slick.css'
import '../../assets/css/plugins/slick-theme.css'
import imageMixin from "@/mixins/imageMixin";

export default {
  name: 'Slider1',
  mixins: [imageMixin],
  components: {Slick},
  data() {
    return {
      settingsSlider: {
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: "#sliderNavSlick",
        responsive: [{
          breakpoint: 768,
          settings: {
            arrows: false,
          }
        }]
      },
      settingsNavSlider: {
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: "#sliderSlick",
        focusOnSelect: true,
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              autoplay: true
            }
          }
        ]
      }
    }
  },
  methods: {
    next() {
      this.$refs.sliderNavSlick.next();
    },
    prev() {
      this.$refs.sliderNavSlick.prev();
    }
  },
}
</script>
